import React from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Breadcrumb from "../Component/Breadcrumb";

const BULLETIN_DATA = [
  {
    title: "Independence Day Special Bulletin 2026",
    linkURL:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LFSGV/public/pdf/Independence_Day_Special_Bulletin_2026.pdf",
  },
  {
    title: "The Patriotic Echoes",
    linkURL:
      "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LFSGV/public/pdf/patriotic_echoes_2026.pdf",
  },
];

function Bulletin() {
  return (
    <>
      <Header />

      <Breadcrumb title="Bulletin" pageName="Bulletin" mid="Download" />

      <div className="innerSection bulletin_container">
        <div className="container">
          <div className="row g-4">
            {BULLETIN_DATA.map((item, index) => (
              <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
                <div className="bulletin_card">
                  <div className="bulletin_card_top">
                    <p className="bulletin_label">
                      Bulletin <span>/ PDF</span>
                    </p>
                  </div>

                  <div className="bulletin_card_body">
                    <h3 className="bulletin_title">{item.title}</h3>
                  </div>

                  <div className="bulletin_card_bottom">
                    <a
                      href={item.linkURL}
                      target="_blank"
                      rel="noreferrer"
                      className="bulletin_download"
                    >
                      <span className="bulletin_download_icon">
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 3V15M12 15L7 10M12 15L17 10"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M5 21H19"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          />
                        </svg>
                      </span>
                      View Bulletin
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Bulletin;
